/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface LinkRobloxAccountRequestContent
 */
export interface LinkRobloxAccountRequestContent {
    /**
     * The ID token returned by Cognito when completing the Roblox OIDC
flow. This token proves control of the Roblox identity and is used
server-side to extract the provider linkage metadata.
     * @type {string}
     * @memberof LinkRobloxAccountRequestContent
     */
    robloxIdToken: string;
}


/**
 * Check if a given object implements the LinkRobloxAccountRequestContent interface.
 */
export function instanceOfLinkRobloxAccountRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "robloxIdToken" in value;
    return isInstance;
}

export function LinkRobloxAccountRequestContentFromJSON(json: any): LinkRobloxAccountRequestContent {
    return LinkRobloxAccountRequestContentFromJSONTyped(json, false);
}

export function LinkRobloxAccountRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkRobloxAccountRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'robloxIdToken': json['robloxIdToken'],
    };
}

export function LinkRobloxAccountRequestContentToJSON(value?: LinkRobloxAccountRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'robloxIdToken': value.robloxIdToken,
    };
}

